export function getLocation(state) {
    return state.location
}

export function getWorkOrderInvoice(state) {
    return state.workOrderInvoiceId
}
